import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../shared/CustomFilterInput";
import AppButton from "../../shared/AppButton";

function AutoSubmit() {
  const { values, submitForm } = useFormikContext();
  useEffect(() => {
    if (values.nationalId && values.nationalId.length === 10) {
      submitForm();
    }
  }, [values.nationalId, submitForm]);

  return null;
}

function ChhiForm({
  setChiReqRecord,
  setSystemType,
  eligibilityId,
  setEligibilityId,
}) {
  const { t } = useTranslation();
  const [chiLoading, setChiLoading] = useState(false);
  const navigate = useNavigate();

  const systemTypes = [
    { id: 1, name: t("Nationals And Residents") },
    { id: 2, name: t("Visitors") },
    { id: 3, name: t("Tourists") },
    { id: 4, name: t("Premium Residents") },
    { id: 5, name: t("Hajj & Umrah Visitors") },
  ];

  const validationSchema = Yup.object().shape({
    systemType: Yup.number().required(t("System Type is required")),
    nationalId: Yup.string().required(t("National Id is required")),
  });

  const addData = async (values) => {
    setChiLoading(true);
    setSystemType(values.systemType);
    try {
      setEligibilityId(null);
      const token = localStorage.getItem("token");
      const tokenWithoutQuotes = token ? token.replace(/"/g, "") : "";
      const response = await fetch(
        `https://api.supergitsa.com/api/check-insurance?id=${values.nationalId}&type=${values.systemType}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenWithoutQuotes}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        setChiLoading(false);

        const result = await response.json();
        const unescapedString = result?.data?.replace(/\\"/g, '"');
        const jsonObject = JSON.parse(unescapedString);

        if (jsonObject.ApiStatus === "Fail") {
          toast.error(jsonObject.ErrorDescription);
        } else if (jsonObject.ApiStatus === "Success") {
          setChiReqRecord(jsonObject);
          toast.success(t("Data Retrieve Successfully!"));
        }
      } else {
        setChiLoading(false);
        throw new Error("Response Issue");
      }
    } catch (error) {
      setChiLoading(false);
      console.log(error);
    }
  };

  return (
    <Formik
      initialValues={{
        systemType: 1,
        nationalId: "",
      }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        addData(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => (
        <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-x-1.5 gap-y-1.5">
            <div>
              <CustomFilterInput
                label={t("System Type")}
                name="systemType"
                isSelect
                value={values.systemType}
                onChange={handleChange}
                onBlur={handleBlur}
                options={systemTypes}
                error={errors.systemType}
                touched={touched.systemType}
                hideErrorText={true}
              />
            </div>

            <div>
              <CustomFilterInput
                label={t("National ID or Iqama")}
                name="nationalId"
                type="text"
                placeholder={t("Enter National ID or Iqama")}
                value={values.nationalId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.nationalId}
                touched={touched.nationalId}
                hideErrorText={true}
              />
            </div>

            <div className="flex items-end">
              <AppButton
                label={t("Request")}
                onClick={handleSubmit}
                disabled={chiLoading}
                startIcon={<PersonSearchIcon className="!text-[16px]" />}
              />
            </div>

            <AutoSubmit />
          </div>
        </div>
      )}
    </Formik>
  );
}

export default ChhiForm;
